import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const StarIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Star",
    children: /*#__PURE__*/_jsx("path", {
      d: "M6.67 31.4c-.24 0-.47-.07-.67-.22-.33-.24-.51-.64-.46-1.04l1-9.49-6.39-7.09c-.27-.3-.36-.73-.24-1.12.13-.39.45-.68.85-.77l9.33-1.99 4.78-8.25a1.142 1.142 0 0 1 1.98 0l4.77 8.26 9.33 1.99c.4.08.72.38.85.77s.04.81-.24 1.12l-6.38 7.09 1 9.49a1.138 1.138 0 0 1-1.6 1.16l-8.72-3.88-8.72 3.88c-.15.07-.31.1-.46.1Zm-3.5-17.9 5.4 6c.22.24.32.56.29.88l-.84 8.03 7.38-3.28c.3-.13.63-.13.93 0l7.37 3.28-.84-8.03c-.03-.32.07-.64.29-.88l5.4-6-7.9-1.68c-.32-.07-.59-.27-.75-.55l-4.04-6.99-4.04 6.99c-.16.28-.43.48-.75.55z"
    })
  }));
};
StarIcon.displayName = 'StarIcon';